module.exports = __webpack_public_path__ + "media/images/arrow-right-7cba764cf70cc4bdd0e69ed6f35d8381.svg";